var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#251163"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13C5.5 17.1421 8.85786 20.5 13 20.5H19.9375C20.2481 20.5 20.5 20.2481 20.5 19.9375C20.5 19.6268 20.2481 19.375 19.9375 19.375H16.9528C19.0823 18.0518 20.5 15.6915 20.5 13C20.5 8.85786 17.1421 5.5 13 5.5C8.85786 5.5 5.5 8.85786 5.5 13ZM13 10.75C13.6213 10.75 14.125 10.2463 14.125 9.625C14.125 9.00368 13.6213 8.5 13 8.5C12.3787 8.5 11.875 9.00368 11.875 9.625C11.875 10.2463 12.3787 10.75 13 10.75ZM13 17.5C13.6213 17.5 14.125 16.9963 14.125 16.375C14.125 15.7537 13.6213 15.25 13 15.25C12.3787 15.25 11.875 15.7537 11.875 16.375C11.875 16.9963 12.3787 17.5 13 17.5ZM9.625 11.875C10.2463 11.875 10.75 12.3787 10.75 13C10.75 13.6213 10.2463 14.125 9.625 14.125C9.00368 14.125 8.5 13.6213 8.5 13C8.5 12.3787 9.00368 11.875 9.625 11.875ZM17.5 13C17.5 12.3787 16.9963 11.875 16.375 11.875C15.7537 11.875 15.25 12.3787 15.25 13C15.25 13.6213 15.7537 14.125 16.375 14.125C16.9963 14.125 17.5 13.6213 17.5 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReel);
export default __webpack_public_path__ + "static/media/reel.e98ec0c47d821c8b3c944c860ca84466.svg";
export { ForwardRef as ReactComponent };